import React from "react";

export default function NotFound() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
        textAlign: "center",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h1 style={{ fontSize: "120px", margin: "0", color: "#333" }}>404</h1>
      <h2 style={{ fontSize: "32px", color: "#666", marginTop: "10px" }}>
        Page Not Found
      </h2>
      <p style={{ fontSize: "16px", color: "#999", marginTop: "10px" }}>
        The page you're looking for doesn't exist.
      </p>
      <button
        onClick={() => window.history.back()}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          fontSize: "16px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Go Back
      </button>
    </div>
  );
}
